<template>
  <div>
    <v-dialog @close="showPriceCheck = false" v-if="showPriceCheck">
      <v-price-check></v-price-check>
    </v-dialog>
    <v-dialog @close="showIsDirty = false" v-if="showIsDirty">
      <h5>Unsaved Changes</h5>

      <d-alert theme="warning" show>
        <i class="fa fa-exclamation-triangle"></i>
        <span><strong>Warning!</strong> There are unsaved changes on this page.</span>
      </d-alert>

      <d-button>Save Changes</d-button>
      <d-button theme="secondary" @click="onDiscardChanges">Discard Changes</d-button>
    </v-dialog>

    <d-container fluid class="main-content-container px-4">

      <div class="page-header row no-gutters py-4">
        <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">Provider</span>
          <h3 class="page-title">{{parking.name}}</h3>
        </div>
      </div>
        <div>
            <d-alert theme="warning" :show="(parking.apiKey) ? true :false" >
              This parking is managed by a Parking Management System externally.
            </d-alert>
        </div>
      <d-row>

        <d-col lg="12">
          <d-card class="card-small">
            <d-card-header class="border-bottom card__tabs">
              <template v-for="(tab, i) in tabs">
                <router-link :to="{name : tab.name}" class="card__tab" exact-active-class="card__tab--active">
                  {{ tab.label }}
                </router-link>
              </template>
            </d-card-header>

            <d-card-body v-if="parking.id !== undefined">
              <general-info v-if="$route.name === 'providers.single'" :parking="parking"  />
              <router-view v-else :parking="parking" ></router-view>
              

            </d-card-body>
          </d-card>
        </d-col>

      </d-row>

    </d-container>
  </div>
</template>

<script>
  import GeneralInfo from "~/components/parkings/GeneralInfo";

  export default {
    components: {GeneralInfo},
    unmounted: function () {
      window.removeEventListener('beforeunload', this.onBeforeUnload);
    },
    mounted: function () {
      window.addEventListener('beforeunload', this.onBeforeUnload);
    },
    methods: {
      onDiscardChanges: function () {
        this.showIsDirty = false;
        this.currentTab = this.nextTab;
        this.nextTab = -1;
      },
    },

    apollo: {
      load: function () {
        return {
          fetchPolicy: 'no-cache',
          variables: {
            provider: this.$route.params.id,
          },
          update: function (data) {
            this.parking = data.provider;
          },
          query: require('~/graphql/GetSingleParking.gql'),
        };
      },
    },

    data: function () {
      return {
        showIsDirty: false,
        showPriceCheck: false,
        currentTab: 0,
        nextTab: -1,
        tabs: [

          {
            label: 'General',
            name: 'providers.single',
          },
          {
            label: 'Business Info',
            name: 'providers.single.business',
          },
          {
            label: 'Options',
            name: 'providers.single.options',
          },
          {
            label: 'Photos',
            name: 'providers.single.photos',
          },
          {
            label: 'Documents',
            name: 'providers.single.documents',
          },
          {
            label: 'Invoices',
            name: 'providers.single.invoices',
          },
          {
            label: 'Users',
            name: 'providers.single.users',
          },
          {
            label: 'Reviews',
            name: 'providers.single.reviews',
          },
          {
            label: 'Service Locations',
            name: 'providers.single.serviceLocations',
          },          


        ],

        parking: {
          availability: 0,
          available: false,
          name: '',
          id: undefined,
        },
      };
    },
  };
</script>
